const messages = {
    scanWithBankApp: "ສະແກນໂດຍໃຊ້ແອັບທະນາຄານຂອງທ່ານ",
    scanWithCreditCardApp: "ສະແກນໂດຍໃຊ້ແອັບບັດເຄຣດິດຂອງທ່ານ",
    scanOrOpenApp: "ສະແກນ ຫຼື ເປີດແອັບເພື່ອສຳເລັດການຊຳລະ",
    scanForPayment: "ສະແກນເພື່ອຊຳລະເງິນ",
    scanWithBankApp: 'ສະແກນດ້ວຍແອັບທະນາຄານເພື່ອຊຳລະ',
    changePaymentWarning: "ເມື່ອທ່ານປ່ຽນວິທີການຊຳລະ, QR Code ເກົ່າຈະໃຊ້ບໍ່ໄດ້ອີກ. ກະລຸນາໃຊ້ວິທີໃໝ່ເທົ່ານັ້ນ.",
    swapShop: "ທ່ານຕ້ອງການປ່ຽນໄປ<br>ຮ້ານໃໝ່ບໍ?",
    swapShopDespt: "ລາຍການທີ່ເລືອກຈາກຮ້ານເກົ່າຈະຖືກບັນທຶກໄວ້ ແລະ ສາມາດສັ່ງໄດ້ພາຍຫຼັງ",
    sorryForInconvenient: 'ຂໍອະໄພໃນຄວາມບໍ່ສະດວກ',
    openAt: 'ເປີດເວລາ',
    shopIsClosedToday: 'ຮ້ານປິດມື້ນີ້',
    checkOrderedItem: 'ກວດສອບລາຍການອາຫານທີ່ສັ່ງ',
    tryAgainIn: 'ລອງໃໝ່ເວລາ',
    lockUserPIN: "ທ່ານໃສ່ PIN ຜິດເກີນ 5 ຄັ້ງ",
    lockUserPINDespt: "ລອງໃໝ່ໃນ 5 ນາທີ",
    inValidPIN: 'PIN ບໍ່ຖືກຕ້ອງ',
    enterPasswordToAccessMenu: "ໃສ່ PIN ເພື່ອເຂົ້າເຖິງເມນູ",
    customersCanGetPasswordFromStaff: "ລູກຄ້າສາມາດຂໍ PIN ຈາກພະນັກງານ",
    tableNotAvailable: "ໂຕະບໍ່ວ່າງ",
    contactStaffToOpenTable: "ຕິດຕໍ່ພະນັກງານເພື່ອເປີດໂຕະ",
    outOfRestaurantRange: "ບໍ່ຢູ່ໃນຂອບເຂດຂອງຮ້ານອາຫານ",
    phoneIsMoreThan100MetersAwayFromRestaurant: "ໂທລະສັບຂອງທ່ານຢູ່ຫ່າງຈາກຮ້ານອາຫານເກີນ 100 ແມັດ",
    restaurantIsCurrentlyClosed: "ຮ້ານອາຫານປິດໃຫ້ບໍລິການຢູ່",
    restaurantOpenHours: "ຫ້ອງຄົວເປີດແຕ່",
    packingSize: 'ຂະໜາດບັນຈຸ',
    shippingDelivery: 'ຈັດສົ່ງ',
    waitForPaymentDelivery: 'ລໍຖ້າການຊຳລະ',
    readyForPcikup: 'ພ້ອມຮັບສິນຄ້າ',
    noNotifyNow: "ບໍ່ມີການແຈ້ງເຕືອນໃນຕອນນີ້",
    noNotifyNowDespt: "ເມື່ອທ່ານເລີ່ມໃຊ້ບໍລິການ, ການແຈ້ງເຕືອນຈະສະແດງຢູ່ນີ້",
    newAddressDespt: "ເພື່ອຄວາມສະດວກໃນການຈັດສົ່ງ, ກະລຸນາປັກໝຸດປາຍທາງທີ່ຖືກຕ້ອງ ແລະ ອະນຸຍາດເຂົ້າເຖິງຕຳແໜ່ງຂອງທ່ານ",
    deleteAddressSuccess: 'ລຶບທີ່ຢູ່ສຳເລັດ',
    createProfileSuccess: "ສ້າງໂປຣໄຟລ໌ສຳເລັດ",
    ex: 'ຕົວຢ່າງ',
    receiverName: 'ຊື່ຜູ້ຮັບ',
    editAddress: 'ແກ້ໄຂທີ່ຢູ່',
    nameInputInvalid: 'ຊື່ບໍ່ຖືກຕ້ອງ',
    openInGoogleMap: 'ເປີດ Google Map',
    pleaseSelectPaymentMethod: 'ກະລຸນາເລືອກວິທີການຊຳລະ',
    noDeliveryAddress: 'ບໍ່ພົບທີ່ຢູ່ຈັດສົ່ງ',
    noDeliveryAddressDespt: 'ກະລຸນາເພີ່ມຂໍ້ມູນທີ່ຢູ່ຈັດສົ່ງ',
    deliveryType: 'ຈັດສົ່ງ',
    pickupType: 'ຮັບເອງ',
    shopIsClose: 'ຮ້ານປິດ',
    openingHoursDespt: 'ເວລາເປີດ-ປິດ',
    contactShop: 'ຕິດຕໍ່ຮ້ານ',
    pickupAtShop: 'ຮັບເອງ',
    thanksForOrderingDespt: 'ຂອບໃຈທີ່ອຸດໜູນ.<br>ຫວັງວ່າຈະໄດ້ພົບທ່ານອີກ!',
    deliveredSuccess: 'ຈັດສົ່ງສຳເລັດ',
    expireIn: 'ໝົດອາຍຸໃນ',
    waitForPayment: 'ລໍຖ້າການຊຳລະ',
    waitForPaymentDespt: "ກະລຸນາລໍຖ້າການຢືນຢັນການຊຳລະຈາກລະບົບ.<br>ຖ້າທ່ານຍັງບໍ່ໄດ້ຊຳລະ, ກະລຸນາຊຳລະພາຍໃນເວລາທີ່ກຳນົດ ເພື່ອຫຼີກລ້ຽງການຍົກເລີກຄຳສັ່ງ.",
    newOrderIn: 'ໃໝ່',
    inputRequestDetails: 'ລະບຸລາຍລະອຽດຄຳຮ້ອງ',
    notification: 'ການແຈ້ງເຕືອນ',
    noticeIfOrderReady: 'ພວກເຮົາຈະແຈ້ງທ່ານເມື່ອຄຳສັ່ງພ້ອມຮັບ',
    orderIsReady: 'ຄຳສັ່ງຂອງທ່ານພ້ອມຮັບແລ້ວ',
    thanksForOrdering: 'ຂອບໃຈທີ່ໃຊ້ບໍລິການ',
    toPay: 'ຊຳລະ',
    letOrder: 'ໄປໜ້າເມນູ ແລະ ເລີ່ມສັ່ງເລີຍ',
    noTransaction: 'ບໍ່ມີລາຍການ',
    menulists: 'ລາຍການເມນູ',
    editPersonalDetails: 'ແກ້ໄຂຂໍ້ມູນ',
    trackOrder: 'ຕິດຕາມຄຳສັ່ງ',
    myAccount: 'ບັນຊີຂອງຂ້ອຍ',
    cart: 'ກະຕ່າ',
    helpCenter: 'ສູນຊ່ວຍເຫຼືອ',
    allPurchaseHistory: 'ປະຫວັດການຊື້',
    purchaseHistory: 'ປະຫວັດການຊື້',
    personalInfo: 'ຂໍ້ມູນສ່ວນຕົວ',
    cutlery: 'ຊ້ອນສ້ອມ',
    km: 'ກມ.',
    totalAmountSum: 'ລວມທັງໝົດ',
    selectedItemList: 'ລາຍການທີ່ເລືອກ',
    iAm: 'ຂ້ອຍແມ່ນ',
    orderedBy: 'ສັ່ງໂດຍ',
    shareQRtoFriend: 'ແຊຣ໌ QR Code',
    share: 'ແຊຣ໌',
    hasItemInBasket: 'ມີລາຍການຢູ່ໃນກະຕ່າ',
    hasItemInBasketDespt: 'ຢ່າລືມສົ່ງໄປຫ້ອງຄົວ',
    updatedAtQR: 'ອັບເດດເມື່ອ',
    orderSent: 'ສົ່ງຄຳສັ່ງໄປຫ້ອງຄົວແລ້ວ',
    orderSentDespt: 'ຮ້ານກຳລັງກະກຽມອາຫານຂອງທ່ານ',
    checkGramdTotalIn: 'ທ່ານສາມາດກວດສອບຍອດລວມໄດ້ທີ່',
    vatNotInclude: 'ລາຄານີ້ບໍ່ລວມພາສີ, ຄ່າບໍລິການ, ແລະ ສ່ວນຫຼຸດ',
    accept: 'ຍອมຮັບ',
    termOfService: 'ເງື່ອນໄຂການໃຫ້ບໍລິການ',
    onPending: 'ລໍຖ້າ',
    OnSuccessOrder: 'ສຳເລັດ',
    prepareingOrder: 'ກຳລັງກະກຽມ',
    deliveringOrder: 'ກຳລັງຈັດສົ່ງ',
    pickupOrderReady: 'ພ້ອມຮັບສິນຄ້າ',
    pickedupOrder: 'ຮັບສິນຄ້າແລ້ວ',
    deliveredOrder: 'ຈັດສົ່ງສຳເລັດ',
    shopReceivedOrder: 'ຮ້ານຮັບຄຳສັ່ງແລ້ວ',
    orderId: 'ລະຫັດຄຳສັ່ງ',
    orderDetails: 'ລາຍລະອຽດຄຳສັ່ງ',
    deliveryFee: 'ຄ່າຈັດສົ່ງ',
    searchDriver: 'ກຳລັງຊອກຫາຄົນຂັບ',
    driverFrom: 'ຄົນຂັບຈາກ',
    change: 'ປ່ຽນ',
    deliveryAddress: 'ທີ່ຢູ່ຈັດສົ່ງ',
    location: 'ຕຳແໜ່ງ',
    addressName: 'ຊື່ທີ່ຢູ່',
    addressNameDespt: 'ເຊັ່ນ: ຊື່ຄອນໂດ, ຊື່ໝູ່ບ້ານ',
    addressDescription: 'ລາຍລະອຽດທີ່ຢູ່',
    addressDescriptionDespt: 'ເຊັ່ນ: ເລກຕຶກ, ຊອຍ',
    noteToDriver: 'ໝາຍເຫດເຖິງຄົນຂັບ',
    noteToDriverDespt: 'ຕົວຢ່າງ: ວາງໄວ້ເທິງໂຕະທີ່ທາງເຂົ້າ',
    inputAddressForm: 'ໃສ່ທີ່ຢູ່ຈັດສົ່ງ',
    plsPinAddress: 'ປັກໝຸດຕຳແໜ່ງຂອງທ່ານ',
    pinLocation: 'ປັກໝຸດສະຖານທີ່ຈັດສົ່ງ',
    createNewAddress: 'ສ້າງທີ່ຢູ່ໃໝ່',
    savedAddress: 'ທີ່ຢູ່ທີ່ບັນທຶກໄວ້',
    phoneNumber: 'ເບີໂທລະສັບ',
    noRequired: 'ບໍ່ຈຳເປັນ',
    resendCode: 'ສົ່ງລະຫັດໃໝ່',
    didNotGetCode: 'ບໍ່ໄດ້ຮັບລະຫັດ?',
    resendIn: 'ສົ່ງໃໝ່ໃນ',
    next: 'ຕໍ່ໄປ',
    createAccount: 'ສ້າງບັນຊີ',
    createAccountDespt: 'ກະລຸນາຕື່ມແບບຟອມຂ້າງລຸ່ມເພື່ອສ້າງບັນຊີ',
    sendCodeViaSMS: 'ສົ່ງລະຫັດຜ່ານ SMS',
    inputOTP: 'ໃສ່ OTP',
    inputOTPDespt: 'ກະລຸນາໃສ່ລະຫັດ 6 ຫຼັກທີ່ສົ່ງໄປ',
    termAndPolicy: 'ເງື່ອນໄຂ ແລະ ນະໂຍບາຍ',
    termAndPolicy1: 'ໂດຍການໃຊ້ບໍລິການ, ທ່ານຕົກລົງຕາມ',
    termAndPolicy2: 'ກົດເພື່ອອ່ານເງື່ອນໄຂ ແລະ ນະໂຍບາຍຄົບຖ້ວນ',

    loginWithPhoneNumber: 'ເຂົ້າສູ່ລະບົບດ້ວຍເບີໂທ',
    loginWithPhoneNumberDespt: 'ໃສ່ເບີໂທຂອງທ່ານເພື່ອຮັບ OTP ສຳລັບຢືນຢັນຕົວຕົນ',
    backToOrder: 'ກັບໄປເມນູ',
    PaymentMethod: 'ການຊຳລະ',
    paymentAmount: 'ຈຳນວນເງິນ',
    paymentConfirmation: 'ຢືນຢັນການຊຳລະ',
    cancelPayment: 'ຍົກເລີກການຊຳລະ',
    paidSuccess: 'ຊຳລະສຳເລັດ',
    haveNotPurchased: 'ຍັງບໍ່ໄດ້ຊຳລະ',
    haveNotPurchased2: 'ຖ້າການຊຳລະລົ້ມເຫຼວ, ກະລຸນາຕິດຕໍ່ພະນັກງານ',
    canNotOrderItem: 'ທ່ານບໍ່ສາມາດສັ່ງອາຫານຂະນະກຳລັງຊຳລະ',
    checkPaymentStatus: 'ກວດສອບສະຖານະ',
    pendingPayment: 'ລໍຖ້າການຊຳລະ',
    askForReceipt: 'ຖ້າຕ້ອງການໃບຮັບເງິນ, ກະລຸນາຕິດຕໍ່ພະນັກງານ',
    paymentSuccess: 'ຊຳລະສຳເລັດ',
    summaryPayment: 'ສະຫຼຸບ',
    numberOfGuest: 'ຈຳນວນແຂກ',
    closeTab: 'ປິດ',
    addCredit: 'ເພີ່ມບັດເຄຣດິດ',
    QRPayment: 'ຊຳລະດ້ວຍ QR',
    cardPayment: 'ບັດເຄຣດິດ',
    payWithStaff: 'ຊຳລະທີ່ເຄົາເຕີ',
    selectPaymentMethod: 'ເລືອກວິທີການຊຳລະ',
    checkOut: 'ຊຳລະເງິນ',
    startOrderBeforeCallStaff: 'ກະລຸນາສັ່ງອາຫານກ່ອນເອີ້ນພະນັກງານ',
    basket: 'ກະຕ່າ',
    spoon: 'ຂໍຊ້ອນສ້ອມ',
    knife: 'ຂໍມີດ',
    chopstick: 'ຂໍຖູ່',
    cup: 'ຂໍຈອກ',
    plate: 'ຂໍຈານ',
    glass: 'ຂໍແກ້ວ',
    payBill: 'ຂໍຊຳລະ',
    viewAll: 'ເບິ່ງທັງໝົດ',
    recommendMenu: 'ແນະນຳ',
    OnSuccess: 'ສຳເລັດ',
    OnPreparing: 'ກຳລັງກະກຽມ',
    messageSent: 'ກະລຸນາລໍຖ້າພະນັກງານ',
    outOfStock: 'ສິນຄ້າໝົດ',
    QRCode: 'QR Code',
    GenerateQRCode: 'ສ້າງ QR Code',
    ForQROrder: 'ສຳລັບສັ່ງອາຫານ ແລະ ຂໍບໍລິການໃນຮ້ານ',
    QROrderDescription: 'ທ່ານສາມາດສ້າງ QR Code ໃຫ້ລູກຄ້າສະແກນເພື່ອສັ່ງອາຫານ ແລະ ຂໍບໍລິການໃນຮ້ານ',
    SelectTable: 'ເລືອກໂຕະ ແລະ ໃສ່ຈຳນວນແຂກ.',
    shopname: 'ຊື່ຮ້ານ',
    numberOfCustomer: 'ຈຳນວນລູກຄ້າ (ຄົນ)',
    numberOfCustomerDescription: 'ໃສ່ຈຳນວນລູກຄ້າ, ຕ່ຳສຸດ 1 ຄົນ',
    currentUser: 'ຜູ້ໃຊ້',
    guest: 'ແຂກ',
    orderItem: 'ສະຫຼຸບຄຳສັ່ງ',
    orderItemNav: 'ສະຫຼຸບຄຳສັ່ງ',
    callStaff: 'ເອີ້ນພະນັກງານ',
    callStaffDialog: 'ທ່ານຕ້ອງການຄວາມຊ່ວຍເຫຼືອຫຍັງ?',
    cutlery: 'ຂໍຊ້ອນສ້ອມ',
    seasoning: 'ຂໍເຄື່ອງປຸງ',
    refillDrink: 'ຂໍເຕີມເຄື່ອງດື່ມ',
    other: 'ອື່ນໆ',
    tableNumber: 'ໂຕະ',
    menuList: 'ເມນູ',
    selectedItem: 'ສັ່ງອາຫານ',
    selectedItemNav: 'ສັ່ງອາຫານ',
    checkOrderBeforeConfirm: 'ກະລຸນາກວດສອບລາຍການ ແລະ ຍອດລວມກ່ອນສົ່ງໄປຮ້ານ',
    checkOrderBeforeConfirm2: '',
    startOrder: 'ເລີ່ມສັ່ງ',
    foodCategory: 'ໝວດໝູ່',
    searchByName: 'ຄົ້ນຫາສິນຄ້າຕາມຊື່...',
    noPreduct: 'ບໍ່ມີສິນຄ້າ',
    noSelectedProduct: 'ບໍ່ມີລາຍການທີ່ເລືອກ',
    noSelectedProductDespt: 'ຖ້າທ່ານເລືອກສິນຄ້າແລ້ວ, ລາຍການຈະສະແດງຢູ່ໜ້ານີ້',
    backToMenu: 'ໄປເມນູ',
    removeSelected: 'ທ່ານຕ້ອງການລຶບລາຍການນີ້ບໍ?',
    confirmOrder: 'ສົ່ງຄຳສັ່ງ',
    endOfTransection: 'ສິ້ນສຸດການໃຊ້ບໍລິການ',
    endOfTransectionDialog: 'ຖ້າມີບັນຫາໃນການໃຊ້ງານ, ກະລຸນາຕິດຕໍ່ພະນັກງານ',
    note: 'ໝາຍເຫດ',
    orderTime: 'ເວລາສັ່ງ',
    orderMoreFood: 'ກັບໄປເມນູຫຼັກ',
    orderPreparing: 'ພໍ່ຄົວກຳລັງກະກຽມອາຫານ. ກະລຸນາລໍຖ້າ. ອາຫານຈະເສີບໃນໄວໆນີ້',
    orderPreparing2: '',
    sendingOrder: 'ກຳລັງສົ່ງຄຳສັ່ງໄປຫ້ອງຄົວ...',
    login: 'ເຂົ້າສູ່ລະບົບ',
    forgetPassword: 'ລືມລະຫັດຜ່ານ',
    loginWithGmail: 'ເຂົ້າສູ່ລະບົບດ້ວຍ Gmail',
    or: 'ຫຼື',
    loginAsStaff: 'ເຂົ້າສູ່ລະບົບເປັນພະນັກງານ',
    billOrder: 'ບິນສັ່ງ',
    table: 'ໂຕະ',
    billOrderDialog: 'ສະແກນ QR Code ເພື່ອເບິ່ງເມນູ ແລະ ສັ່ງອາຫານ',
    billOrderDialog2: 'ຖ້າມີບັນຫາໃນການໃຊ້ງານ, ກະລຸນາຕິດຕໍ່ພະນັກງານ',
    selectTableAleart: 'ກະລຸນາເລືອກໂຕະກ່ອນສ້າງ QR Code',
    emptyCartDialog: 'ບໍ່ມີລາຍການ',
    emptyCartDialogDespt: 'ຖ້າທ່ານຢືນຢັນຄຳສັ່ງແລ້ວ, ລາຍການຈະສະແດງຢູ່ໜ້ານີ້',
    served: 'ເສີບແລ້ວ',
    contactOurStaff: 'ຕິດຕໍ່ພະນັກງານ',
    contactOurStaff2: 'ໃນກໍລະນີຕ້ອງການຄວາມຊ່ວຍເຫຼືອ',
    addToCart: 'ເພີ່ມໃສ່ກະຕ່າ',
    noteToShop: 'ໝາຍເຫດເຖິງຮ້ານ',
    addYourRequest: 'ເພີ່ມຄຳຮ້ອງຂອງທ່ານ',
    branchName: 'ຊື່ສາຂາ',
    businessType: 'ປະເພດທຸລະກິດ',
    taxID: 'ເລກປະຈຳຕົວຜູ້ເສຍອາກອນ',
    vat: 'ພາສີ',
    exclusive: 'ບໍ່ລວມພາສີ',
    inclusive: 'ລວມພາສີ',
    serviceCharge: 'ຄ່າບໍລິການ',
    address: 'ທີ່ຢູ່',
    address1: 'ທີ່ຢູ່ ແຖວ 1',
    address2: 'ທີ່ຢູ່ ແຖວ 2',
    tel: 'ໂທ',
    businessType1: 'ທົ່ວໄປ',
    businessType2: 'ຮ້ານອາຫານ',
    businessType3: 'ໂຮງແຮມ',
    shopopen: 'ເປີດ - ປິດ',
    open: 'ເປີດ',
    closed: 'ປິດ',
    languagetxt: 'ພາສາ',
    language: 'ພາສາ ແລະ ເຂດເວລາ',
    languageTH: 'ໄທ',
    languageEN: 'ອັງກິດ',
    setting: 'ການຕັ້ງຄ່າ',
    shop: 'ຮ້ານ',
    timezone: 'ເຂດເວລາ',
    deliveryProviders: 'ຜູ້ໃຫ້ບໍລິການຈັດສົ່ງ',
    adddeliveryProviders: 'ເພີ່ມຜູ້ໃຫ້ບໍລິການ',
    lastUpdate: 'ອັບເດດຫຼ້າສຸດ',
    logo: 'ໂລໂກ',
    updateData: 'ອັບເດດຂໍ້ມູນ',
    submit: 'ສົ່ງ',
    cancel: 'ຍົກເລີກ',
    normal: 'ປົກກະຕິ',
    loading: 'ກຳລັງໂຫຼດ...',
    editing: 'ແກ້ໄຂ',
    confirmUpdate: 'ທ່ານຕ້ອງການອັບເດດຂໍ້ມູນບໍ?',
    selectedShoptype: 'ເລືອກປະເພດທຸລະກິດ...',
    selectshop: 'ເລືອກສາຂາ',
    save: 'ບັນທຶກ',
    reporttxt: 'ລາຍງານ',
    general: 'ທົ່ວໄປ',
    signOut: 'ອອກຈາກລະບົບ',
    registration: '',
    unit: 'ໜ່ວຍ',
    category: 'ໝວດໝູ່',
    product: 'ສິນຄ້າ',
    export: 'ສົ່ງອອກ',
    exportKBank: 'ສົ່ງອອກ K-Bank',
    date: 'ວັນທີ',
    to: 'ເຖິງ',
    status: 'ສະຖານະ',
    vatAmount: 'ພາສີ',
    netTotalNonVAT: 'ລວມ (ບໍ່ລວມພາສີ)',
    receiptNumber: 'ເລກໃບຮັບ',
    grandTotal: 'ຍອດລວມທັງໝົດ',
    netAmountVATTotal: 'ຍອດລວມຍ່ອຍ',
    netTotalIncVAT: 'ລວມ (ລວມພາສີ)',
    proofOfPayment: 'ຫຼັກຖານການຊຳລະ',
    paymentType: 'ປະເພດການຊຳລະ',
    paymentType0: 'ເງິນສົດ',
    paymentType1: 'ບັດເຄຣດິດ',
    paymentType2: 'ຄູປອງ',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: 'ມັດຈຳ',
    paymentType7: 'ຈັດສົ່ງ',
    paymentType8: 'ອອນໄລ',
    paymentType9: 'Line Pay',
    paymentType10: 'ຊຳລະແບບກຳນົດເອງ',
    paymentType12: 'KBank',
    paid: 'ຈຳນວນຊຳລະ',
    sentSuccessfully: 'ສົ່ງສຳເລັດ',
    pluCode: 'ບາໂຄ້ດ',
    netAmount: 'ຍອດສຸດທິ',
    discount: 'ສ່ວນຫຼຸດ',
    timeOfOrder: 'ເວລາສັ່ງ',
    orderDate: 'ວັນທີສັ່ງ',
    preparing: 'ກຳລັງກະກຽມ',
    paymentDetail: 'ລາຍລະອຽດການຊຳລະ',
    orderNumber: 'ເລກທີ່ຄຳສັ່ງ',
    delivered: 'ກຳນົດສົ່ງ',
    deliveredDate: 'ເວລານຳສົ່ງ',
    payment: 'ການຊຳລະ',
    productName: 'ຊື່ສິນຄ້າ',
    quantity: 'ຈຳນວນ',
    priceUnit: ' ລາຄາ / ໜ່ວຍ',
    baht: 'ບາດ',
    profit: 'ກຳໄລ',
    sales: 'ຍອດຂາຍ',
    billAmount: 'ຍອດບິນ',
    total: 'ລວມ',
    bill: 'ບິນ',
    discountAmount: 'ຈຳນວນສ່ວນຫຼຸດ',
    averageBill: 'ສະເລ່ຍ / ບິນ',
    voidbillTotal: 'ຍອດບິນຍົກເລີກ',
    salesByDaily: 'ຍອດຂາຍລາຍວັນ',
    salesByMonth: 'ຍອດຂາຍລາຍເດືອນ',
    bestSellers: 'ສິນຄ້າຂາຍດີ',
    bestSellerstype: 'ໝວດໝູ່ຂາຍດີ',
    salesBydate: 'ຍອດຂາຍຕາມວັນທີ',
    number: 'ລຳດັບ',
    categoryName: 'ຊື່ໝວດໝູ່',
    newOrder: 'ສົ່ງຄຳສັ່ງ',
    reject: 'ປະຕິເສດ',
    inProgressTime: 'ເວລາດຳເນີນການ',
    rejectTime: 'ເວລາປະຕິເສດ',
    cancelTime: 'ເວລາຍົກເລີກ',
    cause: 'ສາເຫດ',
    preparingToShip: 'ກຳລັງກະກຽມ',
    totalAmount: 'ລວມ',
    order: 'ຄຳສັ່ງ',
    deposit: 'ມັດຈຳ',
    billSave: 'ບັນທຶກ',
    ReceivingOrder: 'ເປີດໂຕະ/ຮັບຄຳສັ່ງ',
    orderNo: 'ເລກຄຳສັ່ງ',
    remark: 'ໝາຍເຫດ',
    receiptStatus: 'ສະຖານະໃບຮັບ',
    back: 'ກັບ',
    detail: 'ລາຍລະອຽດ',
    countSales: 'ຈຳນວນ',
    onhandQty: 'ຍອດຄົງເຫຼືອ',
    stdCost: 'ຕົ້ນທຶນ',
    employees: 'ພະນັກງານ',
    employeesname: 'ຊື່ພະນັກງານ',
    salesTotal: 'ຍອດຂາຍລວມ',
    totalBill: 'ຈຳນວນບິນທັງໝົດ',
    billActive: 'ຈຳນວນບິນຂາຍ',
    billVoice: 'ຈຳນວນບິນຍົກເລີກ',
    billDeposit: 'ຈຳນວນບິນມັດຈຳ',
    discountItem: 'ສ່ວນຫຼຸດລາຍການລວມ',
    billDiscountAmount: 'ສ່ວນຫຼຸດບິນລວມ',
    billDiscount: 'ຈຳນວນບິນສ່ວນຫຼຸດ',
    payTotal: 'ຍອດຊຳລະລວມ',
    deliveryProvider: 'ຜູ້ໃຫ້ບໍລິການຈັດສົ່ງ',
    deliveryDetail: 'ລາຍລະອຽດການຈັດສົ່ງ',
    customDetail: 'ລາຍລະອຽດການຊຳລະແບບກຳນົດເອງ',
    customPaymentName: 'ຊື່ການຊຳລະແບບກຳນົດເອງ',
    firstInvoiceNO: 'ເລກບິນທຳອິດ',
    lastInvoiceNO: 'ເລກບິນສຸດທ້າຍ',
    roundNo: 'ຮອບທີ',
    closeAt: 'ປິດເວລາ',
    closeBy: 'ປິດໂດຍ',
    totalCashSales: 'ຍອດຂາຍເງິນສົດລວມ',
    initialChange: 'ເງິນທອນເລີ່ມຕົ້ນ',
    totalCashIn: 'ເງິນສົດເຂົ້າລວມ',
    totalCashOut: 'ເງິນສົດອອກລວມ',
    actualInDrawer: 'ເງິນຈິງໃນລິ້ນຊັກ',
    expectedInDrawer: 'ເງິນທີ່ຄວນມີໃນລິ້ນຊັກ',
    difference: 'ຜົນຕ່າງ',
    voidBillDetail: 'ລາຍລະອຽດບິນຍົກເລີກ',
    cancelBy: 'ຍົກເລີກໂດຍ',
    cancelDate: 'ວັນທີຍົກເລີກ',
    searchByEmployees: 'ຄົ້ນຫາຕາມພະນັກງານ',
    search: 'ຄົ້ນຫາ',
    timeIn: 'ລົງເວລາເຂົ້າ',
    timeOut: 'ລົງເວລາອອກ',
    time: 'ເວລາ',
    hours: 'ຊົ່ວໂມງ',
    seconds: 'ວິນາທີ',
    netTotal: 'ລວມ',
    reason: 'ເຫດຜົນ',
    searchByProduct: 'ຄົ້ນຫາຕາມສິນຄ້າ',
    sortBy: 'ຈັດລຽງຕາມ',
    last: 'ຫຼ້າສຸດ',
    price: 'ລາຄາສິນຄ້າ',
    sortByNumMin: 'ລາຄາຕ່ຳສຸດ',
    sortByNumMax: 'ລາຄາສູງສຸດ',
    documentNo: 'ເລກເອກະສານ',
    transactionType: 'ປະເພດລາຍການ',
    updatedBy: 'ອັບເດດໂດຍ',
    transactionType1: 'ຂາຍ',
    transactionType2: 'ຄືນເງິນ',
    transactionType3: 'ນຳສິນຄ້າເຂົ້າ',
    transactionType4: 'ນຳສິນຄ້າອອກ',
    transactionType5: 'ປັບສະຕັອກເຂົ້າ',
    transactionType6: 'ປັບສະຕັອກອອກ',
    transactionType7: 'ແລກຄະແນນ',
    transactionType8: 'ລຶບສະຕັອກເຂົ້າ',
    transactionType9: 'ລຶບສະຕັອກອອກ',
    transactionType10: 'ແກ້ໄຂສະຕັອກເຂົ້າ',
    transactionType11: 'ແກ້ໄຂສະຕັອກອອກ',
    billNo: 'ເລກບິນ',
    docTotal: 'ລວມ',
    customer: 'ລູກຄ້າ',
    username: 'ຊື່ຜູ້ໃຊ້',
    dateOfBill: 'ວັນທີບິນ',
    selectDate: 'ເລືອກວັນທີ',
    dialogSelectCategory: 'ກະລຸນາເລືອກໝວດໝູ່ເພື່ອຄົ້ນຫາ',
    dialogUpdateDocumentSuccess: 'ອັບເດດເອກະສານສຳເລັດ',
    dialogfound: 'ຂໍ້ມູນທີ່ໃສ່ບໍ່ຖືກຕ້ອງ.',
    isVatIncluded: 'ລວມພາສີແລ້ວບໍ',
    vatIccludes: 'ພາສີມູນຄ່າເພີ່ມ',
    confirmStock: 'ຢືນຢັນສະຕັອກ',
    confirm: 'ຢືນຢັນ',
    deleteDoc: 'ລຶບເອກະສານ',
    confirmUpdateDocModal: 'ທ່ານຕ້ອງການອັບເດດເອກະສານສະຕັອກບໍ?',
    confirmSaveDoc: 'ຢືນຢັນບັນທຶກເອກະສານ',
    confirmDeleteDoc: 'ຢືນຢັນລຶບເອກະສານ',
    confirmDeleteModal: 'ທ່ານຕ້ອງການລຶບເອກະສານສະຕັອກບໍ?',
    dialogSaveDocumentSuccess: 'ບັນທຶກເອກະສານສຳເລັດ',
    createStockIn: 'ສ້າງເອກະສານນຳເຂົ້າສະຕັອກ',
    confirmSaveDocModal: 'ທ່ານຕ້ອງການບັນທຶກເອກະສານສະຕັອກບໍ?',
    selectShopPlease: 'ກະລຸນາເລືອກຮ້ານ',
    selectProductPlease: 'ກະລຸນາເລືອກສິນຄ້າ',
    duplicateProduct: 'ທ່ານເລືອກລາຍການນີ້ແລ້ວ.',
    productInvilid: 'ລາຍການທີ່ທ່ານເລືອກບໍ່ຖືກຕ້ອງ. ກະລຸນາຕິດຕໍ່ຜູ້ດູແລລະບົບ.',
    confirmStockOut: 'ຢືນຢັນນຳສິນຄ້າອອກ',
    dialogSaveDocumentOutSuccess: 'ບັນທຶກເອກະສານສຳເລັດ',
    confirmSaveDocStockOutModal: 'ທ່ານຕ້ອງການບັນທຶກເອກະສານນຳສິນຄ້າອອກບໍ?',
    adjustDocType: 'ປະເພດເອກະສານປັບສະຕັອກ',
    adjustDocType1: 'ເພີ່ມ',
    adjustDocType2: 'ຫຼຸດ',
    beforeAdjust: 'ກ່ອນປັບສະຕັອກ',
    afterAdjust: 'ຫຼັງປັບສະຕັອກ',
    adjust: 'ປັບສະຕັອກ',
    createDoucument: 'ສ້າງເອກະສານ',
    transferType: 'ປະເພດການໂອນ',
    transferType1: 'ໂອນເຂົ້າ',
    transferType2: 'ໂອນອອກ',
    new: 'ໃໝ່',
    finish: 'ສຳເລັດ',
    refDocument: 'ເອກະສານອ້າງອິງ',
    statusDoc: 'ສະຖານະເອກະສານ',
    dialogSaveTransferDocumentSuccess: 'ສ້າງເອກະສານໂອນສຳເລັດ',
    destinationShop: 'ຮ້ານປາຍທາງ',
    destinationShopBranch: 'ສາຂາປາຍທາງ',
    sourceBranch: 'ສາຂາຕົ້ນທາງ',
    sourceShop: 'ຮ້ານຕົ້ນທາງ',
    sourceAddress: 'ທີ່ຢູ່ຕົ້ນທາງ',
    destinationAddress: 'ທີ່ຢູ່ປາຍທາງ',
    saveTransfer: 'ບັນທຶກການໂອນສະຕັອກ',
    confirmSaveTransfer: 'ທ່ານຕ້ອງການບັນທຶກການໂອນສະຕັອກບໍ?',
    savinserviceChargegDoc: 'ກຳລັງບັນທຶກເອກະສານ',
    selectdestinationPlease: 'ກະລຸນາເລືອກສາຂາປາຍທາງ',
    validatedestinationproduct: "ສາຂາປາຍທາງບໍ່ມີສິນຄ້ານີ້",
    validateProduct: 'ກະລຸນາເລືອກສິນຄ້າ',
    created_by: 'ໂດຍ',
    receive: 'ຮັບ',
    updateDoc: 'ອັບເດດເອກະສານ',
    cancelDoc: 'ຍົກເລີກເອກະສານ',
    confirmCancelDoc: 'ທ່ານຕ້ອງການຍົກເລີກເອກະສານນີ້ບໍ?',
    cancelingDoc: 'ກຳລັງຍົກເລີກເອກະສານ',
    updatingDoc: 'ກຳລັງອັບເດດເອກະສານ',
    updateDocFail: "ບໍ່ສາມາດອັບເດດເອກະສານໄດ້",
    cancelDocSuccess: 'ຍົກເລີກເອກະສານສຳເລັດ',
    cancelDocFail: "ບໍ່ສາມາດຍົກເລີກເອກະສານໄດ້",
    refDocumentTransfer: 'ເອກະສານອ້າງອິງ',
    comfrimTransferIn: 'ຢືນຢັນໂອນສະຕັອກເຂົ້າ',
    dilogcomfrimTransferIn: 'ທ່ານຕ້ອງການໂອນສະຕັອກເຂົ້າບໍ?',
    transferInDetail: 'ລາຍລະອຽດການໂອນສະຕັອກ',
    totalNet: 'ຍອດສຸດທິ',
    confirmAdjust: 'ຢືນຢັນປັບສະຕັອກ',
    createStockOut: 'ສ້າງເອກະສານນຳສິນຄ້າອອກ',
    favorite: 'ທີ່ມັກ',
    isOnScreen: 'ສະແດງໜ້າຈໍ',
    negotiatePrice: 'ລາຄາຕໍ່ລອງ',
    productTypeP: 'ສິນຄ້າທົ່ວໄປ',
    productTypeBOM: 'ສິນຄ້າປະກອບ',
    productTypeSN: 'ສິນຄ້າມີ Serial',
    productTypeSV: 'ບໍລິການ (ບໍ່ມີສະຕັອກ)',
    productPLU: 'ຂະໜາດບັນຈຸອື່ນ',
    productBOM: 'ວັດຖຸດິບ',
    productSN: 'Serial Number',
    morePrice: 'ລາຄາອື່ນ',
    cost: 'ຕົ້ນທຶນ',
    quantityPrice: 'ຈຳນວນ',
    exceedUc: 'ລາຄາ',
    changeImg: 'ປ່ຽນຮູບ',
    addProduct: 'ເພີ່ມສິນຄ້າ',
    selectImg: 'ເລືອກຮູບ',
    deleteImg: 'ລຶບຮູບ',
    selectImgFromPC: 'ເລືອກຮູບຈາກຄອມພິວເຕີ',
    confirmSaveImgDialog: 'ທ່ານຕ້ອງການບັນທຶກສິນຄ້າບໍ?',
    confirmSaveImg: 'ຢືນຢັນບັນທຶກສິນຄ້າ.',
    addPrice: 'ເພີ່ມລາຄາ',
    editPrice: 'ແກ້ໄຂລາຄາ',
    dialigDeleteProduct: 'ທ່ານຕ້ອງການລຶບສິນຄ້າບໍ?',
    confirmDeleteProduct: 'ຢືນຢັນລຶບສິນຄ້ານີ້.',
    productType: 'ປະເພດສິນຄ້າ',
    countProduct: 'ຈຳນວນສິນຄ້າ',
    addUnit: 'ເພີ່ມໜ່ວຍ',
    editUnit: 'ແກ້ໄຂໜ່ວຍ',
    active: 'ເປີດໃຊ້ງານ',
    inactive: 'ປິດໃຊ້ງານ',
    confirmSaveUnitDialog: 'ທ່ານຕ້ອງການບັນທຶກໜ່ວຍບໍ?',
    confirmSaveUnit: 'ຢືນຢັນບັນທຶກໜ່ວຍນີ້.',
    dialigDeleteUnit: 'ທ່ານຕ້ອງການລຶບໜ່ວຍບໍ?',
    confirmDeletUnit: 'ຢືນຢັນລຶບໜ່ວຍນີ້.',
    confirmSaveCategoryDialog: 'ທ່ານຕ້ອງການບັນທຶກໝວດໝູ່ບໍ?',
    confirmSaveCategory: 'ຢືນຢັນບັນທຶກໝວດໝູ່ນີ້.',
    dialigDeleteCategory: 'ທ່ານຕ້ອງການລຶບໝວດໝູ່ບໍ?',
    confirmDeletCategory: 'ຢືນຢັນລຶບໝວດໝູ່.',
    addCategory: 'ເພີ່ມໝວດໝູ່',
    editCategory: 'ແກ້ໄຂໝວດໝູ່',
    bgColor: 'ສີພື້ນຫຼັງ',
    selectbgColor: 'ເລືອກສີພື້ນຫຼັງ',
    validateCategoryname: 'ກະລຸນາໃສ່ຊື່ໝວດໝູ່.',
    sequence: 'ລຳດັບ',
    enterProduct: 'ກະລຸນາໃສ່ຊື່ສິນຄ້າ.',
    enterPrice: 'ກະລຸນາໃສ່ລາຄາສິນຄ້າ.',
    selectCategory: 'ກະລຸນາເລືອກໝວດໝູ່ສິນຄ້າ.',
    selectUnit: 'ກະລຸນາເລືອກໜ່ວຍສິນຄ້າ.',
    confirmSaveProduct: 'ທ່ານຕ້ອງການບັນທຶກສິນຄ້ານີ້ບໍ?',
    confirmSaveProductPrice: 'ທ່ານຕ້ອງການບັນທຶກລາຄາອື່ນບໍ?',
    validatepackQty: 'ກະລຸນາໃສ່ລາຄາ/ໜ່ວຍ.',
    validatepackUc: 'ກະລຸນາໃສ່ລາຄາ.',
    validatePRU: 'ຂໍ້ມູນຊ້ຳກັນ, ກະລຸນາໃສ່ໃໝ່.',
    createProductSuccess: 'ສ້າງສິນຄ້າສຳເລັດ',
    addSerial: 'ເພີ່ມ Serial',
    add: 'ເພີ່ມ',
    createSerial: 'ສ້າງ Serial Number',
    available: 'ພ້ອມຂາຍ',
    soldOut: 'ໝົດແລ້ວ',
    deleteSuccess: 'ລຶບສຳເລັດ',
    enterSerial: 'ກະລຸນາໃສ່ Serial Number',
    confirmSaveSerial: 'ທ່ານຕ້ອງການບັນທຶກ Serial Number ນີ້ບໍ?',
    confirmDelete: 'ທ່ານຕ້ອງການລຶບ Serial Number ນີ້ບໍ?',
    addProductPLU: 'ເພີ່ມຂະໜາດບັນຈຸ',
    img: 'ຮູບ',
    SKURatio: 'ອັດຕາສ່ວນ',
    editProductPLU: 'ແກ້ໄຂຂະໜາດບັນຈຸ',
    enterSKURatio: 'ກະລຸນາໃສ່ອັດຕາສ່ວນ',
    comfrimDeletePLU: 'ທ່ານຕ້ອງການລຶບຂະໜາດບັນຈຸນີ້ບໍ?',
    useStepPrice: 'ໃຊ້ລາຄາແບບຂັ້ນ',
    addBOM: 'ເພີ່ມວັດຖຸດິບ',
    confirmSaveBOM: 'ທ່ານຕ້ອງການບັນທຶກວັດຖຸດິບບໍ?',
    user: 'ຜູ້ໃຊ້',
    userDetail: 'ລາຍລະອຽດຜູ້ໃຊ້',
    planDetail: 'ລາຍລະອຽດແພັກເກັດ',
    currentPlan: 'ແພັກເກັດປັດຈຸບັນ',
    expireDate: 'ວັນໝົດອາຍຸ',
    startDate: 'ວັນເລີ່ມ',
    dialogSignOut: 'ທ່ານຕ້ອງການອອກຈາກລະບົບບໍ?',
    confirmSignOut: 'ຢືນຢັນອອກຈາກລະບົບ',
    countMember: 'ສະມາຊິກທັງໝົດ',
    addMenber: 'ເພີ່ມສະມາຊິກ',
    searchMember: 'ຄົ້ນຫາຕາມຊື່ ອີເມວ ແລະ ເບີໂທ',
    dateOfMember: 'ວັນທີເປັນສະມາຊິກ',
    recentVisit: 'ເຂົ້າໃຊ້ຫຼ້າສຸດ',
    memberName: 'ຊື່ສະມາຊິກ',
    email: 'ອີເມວ',
    paymentTotal: 'ຍອດຊຳລະລວມ',
    point: 'ຄະແນນ',
    pointtxt: 'ຄະແນນ',
    postalCode: 'ລະຫັດໄປສະນີ',
    saveing: 'ກຳລັງບັນທຶກ...',
    edit: 'ແກ້ໄຂ',
    editMember: 'ແກ້ໄຂສະມາຊິກ',
    deleteing: 'ກຳລັງລຶບ...',
    dialogDeleteMember: 'ທ່ານຕ້ອງການລຶບສະມາຊິກ',
    confirmDeleteMember: 'ຢືນຢັນລຶບ',
    valtdateMember: 'ກະລຸນາຕື່ມຂໍ້ມູນ',
    createMemberSuccess: 'ເພີ່ມສະມາຊິກສຳເລັດ!!',
    updateMemberSuccess: 'ແກ້ໄຂສະມາຊິກສຳເລັດ!!',
    deleteMemberSuccess: 'ລຶບສະມາຊິກສຳເລັດ!!',
    onhandQtyMin: 'ຍອດຄົງເຫຼືອຕ່ຳສຸດ',
    onhandQtyMax: 'ຍອດຄົງເຫຼືອສູງສຸດ',
    onhandQtySort: 'ຍອດຄົງເຫຼືອ',
    showProductAll: 'ສິນຄ້າທຸກປະເພດ',
    updateAt: 'ອັບເດດຫຼ້າສຸດ',
    sortName: 'ຊື່',
    stockUnit: 'ຕົ້ນທຶນ/ໜ່ວຍ',
    deleteCategory: 'ລຶບໝວດໝູ່',
    selectd: 'ເລືອກ',
    searchProduct: 'ຄົ້ນຫາສິນຄ້າ',
    reset: 'ລ້າງ',
    selectdProduct: 'ເລືອກສິນຄ້າ',
    information: 'ຂໍ້ມູນ',
    adjustStockList: 'ລາຍການປັບສະຕັອກ',
    adjustDetail: 'ເພີ່ມສິນຄ້າເຂົ້າລາຍການປັບສະຕັອກ ແລະ ຕັ້ງຄ່າສິນຄ້າ',
    transferoutList: 'ລາຍການໂອນສະຕັອກ',
    addProductTransfer: 'ເພີ່ມສິນຄ້າເຂົ້າລາຍການໂອນສະຕັອກ ແລະ ຕັ້ງຄ່າສິນຄ້າ',
    transferDetail: 'ສິນຄ້ານຳສະຕັອກອອກ ແລະ ຕັ້ງຄ່າສິນຄ້າ',
    transferinList: 'ສິນຄ້ານຳສະຕັອກເຂົ້າ ແລະ ຕັ້ງຄ່າສິນຄ້າ',
    stockOutList: 'ສິນຄ້ານຳອອກ',
    addstockOutList: 'ເພີ່ມສິນຄ້າເຂົ້າລາຍການນຳອອກ ແລະ ຕັ້ງຄ່າສິນຄ້າ',
    stockinList: 'ສິນຄ້ານຳເຂົ້າ',
    addProductStockin: 'ເພີ່ມສິນຄ້າເຂົ້າລາຍການນຳເຂົ້າ ແລະ ຕັ້ງຄ່າສິນຄ້າ',
    checkCount: 'ກວດສອບສະຕັອກ',
    createAdjustStock: 'ສ້າງເອກະສານປັບສະຕັອກ',
    memberDetail: 'ຂໍ້ມູນສະມາຊິກ',
    package: 'ລາຍລະອຽດແພັກເກັດ',
    startPackate: 'ເລີ່ມແພັກເກັດ',
    endPackate: 'ສິ້ນສຸດແພັກເກັດ',
    name: 'ຊື່',
    productImg: 'ຮູບສິນຄ້າ',
    fistname: 'ຊື່',
    lastname: 'ນາມສະກຸນ',
    saveMember: 'ບັນທຶກຂໍ້ມູນ',
    confirmSaveMember: 'ທ່ານຕ້ອງການບັນທຶກສະມາຊິກ',
    yesOrNo: 'ແມ່ນ ຫຼື ບໍ່',
    totaValue: 'ລວມ',
    deleteMember: 'ລຶບສະມາຊິກ',
    frequently: 'ສິນຄ້າທີ່ຊື້ເລື້ອຍ',
    recentPurchase: 'ຊື້ຫຼ້າສຸດ',
    paymentDescription: 'ລາຍລະອຽດການຊຳລະ',
    validateInfomation: 'ກະລຸນາໃສ່ຂໍ້ມູນ',
    validateTel: 'ເບີໂທບໍ່ຖືກຕ້ອງ',
    validateOTP: 'OTP ບໍ່ຖືກຕ້ອງ',
    validateEmail: 'ອີເມວບໍ່ຖືກຕ້ອງ',
    saveSuccess: 'ບັນທຶກສຳເລັດ',
    txtcustomer: 'ລູກຄ້າ',
    customerName: 'ຊື່ລູກຄ້າ',
    customerCount: 'ຈຳນວນລູກຄ້າ',
    addCustomer: 'ເພີ່ມລູກຄ້າ',
    permissionManage: 'ການຈັດການສິດ',
    mainMenu: 'ເມນູຫຼັກ',
    page: 'ໜ້າ',
    show: 'ສະແດງ',
    delete: 'ລຶບ',
    administratorTools: 'ເຄື່ອງມືຜູ້ດູແລລະບົບ',
    deviceName: 'ຊື່ອຸປະກອນ',
    lastSyncProduct: 'ເວລາ Sync ຫຼ້າສຸດ',
    version: 'ເວີຊັ່ນ',
    posstatus: 'ສະຖານະ',
    posNumber: 'ເລກ POS',
    titleSilomconnect: 'ບໍ່ພາດຍອດຂາຍກັບບໍລິການຈາກ',
    updateSilom: 'ອັບເດດຍອດຂາຍປະຈຳວັນຜ່ານ LINE ຟຣີ',
    addfriend: 'ເພີ່ມເພື່ອນ',
    enterToReciveService: 'ກົດເພື່ອຮັບລະຫັດສຳລັບໃຊ້ບໍລິການ.',
    verifyCodeToUsed: 'ເພື່ອເລີ່ມໃຊ້ລະບົບ. ທ່ານສາມາດກົດຮັບລະຫັດເພື່ອຢືນຢັນຕົວຕົນ.',
    verifyfivemin: 'ລະຫັດຢືນຢັນໃຊ້ໄດ້ພາຍໃນ 5 ນາທີ.',
    yourVertify: 'ລະຫັດຢືນຢັນຂອງທ່ານຄື',
    pressCode: 'ກົດຮັບລະຫັດ',
    exCode: 'ລະຫັດໝົດອາຍຸພາຍໃນ',
    sessionEx: 'ເຊດຊັ່ນໝົດອາຍຸ. ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່.',
    refresh: 'ໂຫຼດໃໝ່',
    selectedFile: 'ເລືອກໄຟລ໌',
    fileSize: 'ຂະໜາດໄຟລ໌ບໍ່ເກີນ 2 MB.',
    isBeingToUsed: 'ກຳລັງໃຊ້ງານ',
    notInUse: 'ບໍ່ໄດ້ໃຊ້ງານ',
    delete: 'ລຶບ',
    confirmUpdateInformation: 'ຢືນຢັນອັບເດດຂໍ້ມູນ',
    memberCount: 'ຈຳນວນ',
    orderMachine: 'ອຸປະກອນສັ່ງ',
    textMember: 'ສະມາຊິກ',
    manageShop: 'ຈັດການຂໍ້ມູນຮ້ານ',
    lansetting: 'ຕັ້ງຄ່າພາສາ ແລະ ເຂດເວລາ',
    timezoneSetiing: 'ຕັ້ງຄ່າເຂດເວລາສຳລັບຮ້ານ',
    deliveryProviderSetting: 'ຜູ້ໃຫ້ບໍລິການຈັດສົ່ງສຳລັບຮ້ານ',
    toolsSetting: 'ຈັດການເຄື່ອງ POS ສຳລັບຮ້ານ',
    checkStockPLU: 'ສິນຄ້າມີຍອດຄົງເຫຼືອ < 0',
    searching: 'ກຳລັງຄົ້ນຫາ',
    allProduct: 'ສິນຄ້າທັງໝົດ',
    foundProductOnhand: 'ພົບສິນຄ້າມີຍອດຄົງເຫຼືອ < 0',
    confirmAdjustBefor: 'ທ່ານຕ້ອງການໃຫ້ລະບົບປັບອັດຕະໂນມັດບໍ?',
    requireAdjust: 'ແມ່ນ',
    imrequireAdjust: 'ບໍ່',
    islimitItemTodoc: 'ທ່ານສາມາດເລືອກໄດ້ສູງສຸດ 200 ລາຍການ / 1 ເອກະສານ.',
    barcodePrint: 'ພິมບາໂຄ້ດ',
    printEx: 'ພິມ ແລະ ຕົວຢ່າງ',
    print: 'ພິມ',
    downloadAndExport: 'ດາວໂຫຼດ ແລະ ພິມ',
    selectFormat: 'ເລືອກຮູບແບບກະດາດ',
    peperFormat: 'ຮູບແບບກະດາດ',
    optional: 'ທາງເລືອກ',
    standardA427: 'A4 ມາດຕະຖານ : 27 ລາຍການ / ໜ້າ',
    standardA450: 'A4 ມາດຕະຖານ : 52 ລາຍການ / ໜ້າ',
    standardA460: 'A4 ມາດຕະຖານ : 60 ລາຍການ / ໜ້າ',
    standardA556: 'A4 ມາດຕະຖານ : 56 ລາຍການ / ໜ້າ (ສະຕິກເກີ້ ຂະໜາດ:A5)',
    standardA550: 'ກະດາດ A5 : 52 ລາຍການ / ໜ້າ',
    standardA560: 'ກະດາດ A5 : 60 ລາຍການ / ໜ້າ',
    countBarcode: 'ຈຳນວນບາໂຄ້ດ',
    barcode: 'ບາໂຄ້ດ',
    setFontsize: 'ຕັ້ງຄ່າຟອນ',
    accessPermissionDes: 'ກຳນົດສິດເຂົ້າເຖິງສຳລັບຜູ້ໃຊ້.',
    deleteUser: 'ຢືນຢັນລຶບຜູ້ໃຊ້',
    confirmDeleteUser: 'ທ່ານຕ້ອງການລຶບຜູ້ໃຊ້ບໍ?',
    passAtless: 'ລະຫັດຜ່ານຕ້ອງມີຢ່າງນ້ອຍ 6 ຕົວອັກສອນ.',
    inValidPass: 'ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ',
    createBy: 'ສ້າງໂດຍ',
    adjustAutoDes: "ຖ້າທ່ານບໍ່ຕ້ອງການໃຫ້ລະບົບອັບເດດອັດຕະໂນມັດ ອາດເຮັດໃຫ້ຍອດຄົງເຫຼືອຂອງສິນຄ້າບໍ່ຖືກຕ້ອງ.",
    addUser: 'ເພີ່ມຜູ້ໃຊ້',
    isMenu: 'ສະແດງໃນເມນູສຳລັບລູກຄ້າ',
    menuSmart: 'ຕັ້ງຄ່າເມນູສິນຄ້າ',
    smartSettingTitle: 'ຕັ້ງຄ່າເມນູ',
    smartSetting: 'ຕັ້ງຄ່າເມນູສຳລັບ Silom CRM',
    confirmEnable: 'ທ່ານຕ້ອງການເປີດເມນູບໍ?',
    confirmDisEnable: 'ທ່ານຕ້ອງການປິດເມນູບໍ?',
    confirmSelfOrderEnable: 'ທ່ານຕ້ອງການເປີດເມນູສັ່ງອາຫານເອງບໍ?',
    confirmSelfOrderDisable: 'ທ່ານຕ້ອງການປິດເມນູສັ່ງອາຫານເອງບໍ?',
    enable: 'ເປີດ',
    disable: 'ປິດ',
    usabilityStatus: 'ເປີດໃຊ້ງານ',
    manageSmartOnProduct: 'ທ່ານສາມາດ "ເພີ່ມ/ແກ້ໄຂ" ລາຍການສິນຄ້າທີ່ຕ້ອງການສະແດງໃນເມນູສຳລັບລູກຄ້າທີ່ໜ້ານີ້.',
    manageSmartOnCategory: 'ທ່ານສາມາດ "ເພີ່ມ/ແກ້ໄຂ" ລາຍການໝວດໝູ່ທີ່ຕ້ອງການສະແດງໃນເມນູສຳລັບລູກຄ້າທີ່ໜ້ານີ້.',
    turnonSmart: 'ແລະ ເປີດໃຊ້ເມນູ',
    manageShopDes: 'ທ່ານສາມາດອ້າງອິງຄູ່ມືການໃຊ້ງານໃນ -',
    desSmartMenu: 'ຕັ້ງຄ່າເມນູສິນຄ້າ ສຳລັບສະແດງ E-menu ເທິງ Line ໃຫ້ລູກຄ້າເຂົ້າເຖິງງ່າຍ ແລະ ສາມາດສັ່ງສິນຄ້າດ້ວຍຕົນເອງ.',
    link: 'ລິ້ງ',
    createTranferOut: 'ສ້າງເອກະສານໂອນອອກ',
    roundingValue: 'ປັດເສດ',
    limitItems: 'ສາມາດເລືອກສິນຄ້າສູງສຸດ 200 ລາຍການ',
    IncomeCategory: 'ລາຍຮັບ',
    ExpenseCategory: 'ລາຍຈ່າຍ',
    saveBy: 'ບັນທຶກໂດຍ',
    saveDate: 'ວັນທີບັນທຶກ',
    drawerCate: 'ໝວດໝູ່',
    openingHours: 'ເວລາເປີດ-ປິດ',
    shopLocation: 'ທີ່ຕັ້ງຮ້ານ',
    sunday: 'ວັນອາທິດ',
    monday: 'ວັນຈັນ',
    tuesday: 'ວັນອັງຄານ',
    wednesday: 'ວັນພຸດ',
    thursday: 'ວັນພະຫັດ',
    friday: 'ວັນສຸກ',
    saturday: 'ວັນເສົາ',
    lat: 'ລະຕິຈູດ',
    lng: 'ລອງຈິຈູດ',
    shopCoverSetting: 'ຕັ້ງຄ່າໜ້າປົກຮ້ານ',
    shopCoverSettingDes: 'ຕັ້ງຄ່າໜ້າປົກຮ້ານສຳລັບສະແດງຢູ່ໜ້າຈໍລູກຄ້າ',
    locationSettingDes: 'ຕັ້ງຄ່າສະຖານທີ່',
    updatelocation: 'ອັບເດດສະຖານທີ່',
    searchLocation: 'ຄົ້ນຫາສະຖານທີ່',
    imaginaryLine: 'ເສັ້ນຂອບເຂດ',
    openingHoursDes: 'ຕັ້ງຄ່າເວລາເປີດ-ປິດສຳລັບຮ້ານ',
    paymentDescriptionConfig: 'ເລືອກວິທີການຊຳລະ',
    creditCard: 'ບັດເຄຣດິດ',
    promptPay: 'Promptpay',
    coupon: 'ຄູປອງ',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: 'ເດືອນ',
    dayMY: 'ວັນທີ',
    item: 'ລາຍການ',
    byStockIn: 'ນຳສະຕັອກເຂົ້າ',
    stockOutOther: 'ອື່ນໆ',
    drawerSales: 'ຍອດຂາຍ',
    sumIncomeExpenses: 'ສະຫຼຸບລາຍຮັບ-ລາຍຈ່າຍສຳລັບ',
    incomeOther: 'ລາຍຮັບອື່ນ',
    loss: 'ຂາດທຶນ',
    grossProfit: 'ກຳໄລລວມ',
    newUser: 'ຜູ້ໃຊ້ໃໝ່',
    userType: 'ປະເພດຜູ້ໃຊ້',
    password: 'ລະຫັດຜ່ານ',
    confirmPassword: 'ຢືນຢັນລະຫັດຜ່ານ',
    ParticipatingProducts: 'ເລືອກສິນຄ້າ',
    descriptionSilomOrder: 'ເລືອກສິນຄ້າສຳລັບ order.silompos.com',
    cashierManagement: 'ຈັດການແຄດເຊຍ',
    cashierManageButton: 'ຈັດການ',
    cashierUsernamePassword: 'ຊື່ຜູ້ໃຊ້/ລະຫັດຜ່ານ',
    cashierCRUDDescription: 'ສຳລັບເຂົ້າສູ່ລະບົບ order.silompos.com',
    password: 'ລະຫັດຜ່ານ',
    placeholderPassword: 'ຢ່າງນ້ອຍ 6 ຕົວອັກສອນ',
    resetPassword: 'ລ້າງລະຫັດຜ່ານ',
    oldPassword: 'ລະຫັດຜ່ານເກົ່າ',
    oldPasswordPlaceholder: 'ລະຫັດຜ່ານເກົ່າ',
    newPassword: 'ລະຫັດຜ່ານໃໝ່',
    purchaseDetail: 'ລາຍລະອຽດການຊື້',
    uploadImage: 'ອັບໂຫຼດຮູບ',
    keyword: 'ຄຳຄົ້ນຫາ',
    firstname: 'ຊື່',
    lastname: 'ນາມສະກຸນ',
    province: 'ແຂວງ',
    district: 'ເມືອງ',
    subdistrict: 'ບ້ານ',
    addressNumber: 'ທີ່ຢູ່',
    setAsDefaultAddress: 'ຕັ້ງເປັນທີ່ຢູ່ເລີ່ມຕົ້ນ',
    setAsTaxAddress: 'ຕັ້ງເປັນທີ່ຢູ່ອອກໃບກຳກັບພາສີ',
    setAsShippingAddress: 'ຕັ້ງເປັນທີ່ຢູ່ຈັດສົ່ງ',
    contact: 'ຕິດຕໍ່',
    setAsDefault: 'ຕັ້ງເປັນເລີ່ມຕົ້ນ',
    addressLists: 'ລາຍການທີ່ຢູ່',
    default: 'ເລີ່ມຕົ້ນ',
    taxAddress: 'ໃບກຳກັບພາສີ',
    shippingAddress: 'ຈັດສົ່ງ',
    addAddress: 'ເພີ່ມ',
    createdAt: 'ສ້າງເມື່ອ',
    updatedAt: 'ອັບເດດເມື່ອ',
    by: 'ໂດຍ',
    readyForSale: 'ພ້ອມຂາຍ',
    sold: 'ຂາຍແລ້ວ',
    delete: 'ລຶບ',
    items: 'ລາຍການ',
    itemDiscount: 'ສ່ວນຫຼຸດລາຍການ',
    failedToSave: 'ບັນທຶກບໍ່ສຳເລັດ!',
    dateOfBirth: 'ວັນເດືອນປີເກີດ',
    menu: 'ເມນູ',
    dashboardMenu: 'ແດດບອດ',
    transactionMenu: 'ລາຍການ',
    currentBillMenu: 'ບິນປັດຈຸບັນ',
    reportMenu: 'ລາຍງານ',
    orderDeviceMenu: 'ອຸປະກອນສັ່ງ',
    memberMenu: 'ສະມາຊິກ',
    inventoryMenu: 'ສະຕັອກ',
    productMenu: 'ສິນຄ້າ',
    selfOrderMenu: 'ຊ່ອງທາງການຂາຍ',
    settingMenu: 'ການຕັ້ງຄ່າ',
    salesReportByDate: 'ຍອດຂາຍຕາມວັນທີ',
    salesReportByBill: 'ຍອດຂາຍຕາມລາຍລະອຽດບິນ',
    salesQuantitySummaryByProductReport: 'ຍອດຂາຍຕາມສິນຄ້າ',
    quantitySummaryByPLUReport: 'ຍອດຂາຍຕາມສິນຄ້າ (PLU)',
    nonSellingProduct: 'ສິນຄ້າທີ່ບໍ່ໄດ້ຂາຍ',
    salesSummaryByCashierReport: 'ຍອດຂາຍຕາມແຄດເຊຍ',
    salesSummaryByCategoryReport: 'ຍອດຂາຍຕາມໝວດໝູ່',
    paymentReport: 'ການຊຳລະ',
    salesTaxReport: 'ພາສີຍອດຂາຍ',
    drawerReport: 'ລິ້ນຊັກ',
    voidBillReport: 'ບິນຍົກເລີກ',
    timesheetReport: 'ເວລາເຮັດວຽກ',
    stockInByListReport: 'ນຳສະຕັອກເຂົ້າຕາມສິນຄ້າ',
    stockOutByListReport: 'ນຳສະຕັອກອອກຕາມສິນຄ້າ',
    nonAdjustStockProductReport: 'ສິນຄ້າທີ່ບໍ່ໄດ້ປັບສະຕັອກ',
    exportProductReport: 'ສົ່ງອອກສິນຄ້າ',
    salesSummaryByOrderReport: 'ຕາມອຸປະກອນສັ່ງ',
    salesSummaryProductByOrderReport: 'ຕາມສິນຄ້າ',
    voidBillByOrderReport: 'ບິນຍົກເລີກ',
    inventoryReport: 'ລາຍງານສະຕັອກ',
    inventoryReportByPLU: 'ລາຍງານສະຕັອກຕາມ PLU',
    inventoryReportBySerial: 'ລາຍງານສະຕັອກຕາມ Serial No.',
    stockMovement: 'ການເຄື່ອນໄຫວສະຕັອກ',
    stockInDocument: 'ເອກະສານນຳສະຕັອກເຂົ້າ',
    stockOutDocument: 'ເອກະສານນຳສະຕັອກອອກ',
    adjustStockDocument: 'ເອກະສານປັບສະຕັອກ',
    selfOrder: 'ສັ່ງອາຫານເອງ',
    cashier: 'ແຄດເຊຍ',
    permission: 'ສິດ',
    menuSetting: 'ຕັ້ງຄ່າເມນູ',
    management: {
        txtManagement: 'ຈັດການ',
        user: 'ບັນຊີ',
        shopBranch: 'ຮ້ານ ແລະ ສາຂາ',
        productManagement: 'ສິນຄ້າ',
        unitManagement: 'ໜ່ວຍ',
        categorytManagement: 'ໝວດໝູ່',
        inventory: 'ສະຕັອກ',
        stockIn: 'ນຳສະຕັອກເຂົ້າ',
        stockOut: 'ນຳສະຕັອກອອກ',
        adjustStock: 'ປັບສະຕັອກ',
        checkStock: 'ກວດສອບສະຕັອກ',
        stockMovement: 'ການເຄື່ອນໄຫວສະຕັອກ',
        transferStock: 'ໂອນສະຕັອກ',
        reportByPLU: 'ລາຍງານສະຕັອກຕາມ PLU',
        reportBySKU: 'ລາຍງານສະຕັອກ',
        txtreportBySKU: 'ລາຍງານສະຕັອກ',
        txtreportByPLU: 'ລາຍງານສະຕັອກຕາມ PLU',
        stockInDoc: 'ເອກະສານນຳສະຕັອກເຂົ້າ',
        stockOutDoc: 'ເອກະສານນຳສະຕັອກອອກ',
        adjustStockDoc: 'ເອກະສານປັບສະຕັອກ',
        transferStockDoc: 'ເອກະສານໂອນສະຕັອກ',
        transferStockInDoc: 'ເອກະສານໂອນສະຕັອກເຂົ້າ',
        transferStockOutDoc: 'ເອກະສານໂອນສະຕັອກອອກ',
    },
    report: {
        dashboard: 'ແດດບອດ',
        transaction: 'ລາຍການ',
        currentbill: 'ບິນປັດຈຸບັນ',
        daily: 'ຕາມວັນທີ',
        txtdaily: 'ລາຍງານຍອດຂາຍຕາມວັນທີ',
        dailyDes: 'ລາຍລະອຽດລາຍງານຍອດຂາຍຕາມວັນທີ',
        sellbyProduct: 'ຕາມລາຍລະອຽດບິນ',
        txtsellbyProduct: 'ລາຍງານຍອດຂາຍຕາມລາຍລະອຽດບິນ',
        sku: 'ຕາມສິນຄ້າ',
        txtsku: 'ລາຍງານຍອດຂາຍຕາມສິນຄ້າ',
        plu: 'ຕາມສິນຄ້າ (PLU)',
        textPlu: 'ລາຍງານຍອດຂາຍຕາມສິນຄ້າ (PLU)',
        paymentreport: 'ລາຍງານການຊຳລະ',
        txtpaymentreport: 'ລາຍງານການຊຳລະ',
        timesheet: 'ເວລາເຮັດວຽກ',
        txtTimesheet: 'ລາຍງານເວລາເຮັດວຽກ',
        unsell: 'ສິນຄ້າທີ່ບໍ່ໄດ້ຂາຍ',
        txtUnsell: 'ສິນຄ້າທີ່ບໍ່ໄດ້ຂາຍ',
        byCategory: 'ຕາມໝວດໝູ່',
        txtbyCategory: 'ລາຍງານຍອດຂາຍຕາມໝວດໝູ່',
        byCashier: 'ຕາມແຄດເຊຍ',
        txtbyCashier: 'ລາຍງານຍອດຂາຍຕາມແຄດເຊຍ',
        salesTax: 'ລາຍງານພາສີຍອດຂາຍ',
        txtSalesTax: 'ລາຍງານພາສີຍອດຂາຍ',
        voidbill: 'ບິນຍົກເລີກ',
        txtvoidbill: 'ລາຍງານບິນຍົກເລີກ',
        closedSale: 'ປິດການຂາຍ',
        txtCloseSale: 'ລາຍງານລິ້ນຊັກ',
        salesByOrder: 'ສະຫຼຸບຍອດຂາຍ',
        productByOrder: 'ຕາມສິນຄ້າ',
        unsalesByOrder: 'ບິນຍົກເລີກ',
        txtDeliveryRoport: 'ລາຍງານການຊຳລະຕາມການຈັດສົ່ງ',
        txtCustomReport: 'ລາຍງານການຊຳລະແບບກຳນົດເອງ',
        txtSalesByOrder: 'ຍອດຂາຍສິນຄ້າຕາມອຸປະກອນສັ່ງ',
        txtDailyOrder: 'ລາຍງານຍອດຂາຍຕາມອຸປະກອນສັ່ງ',
        txtViodOrder: 'ບິນຍົກເລີກຕາມອຸປະກອນສັ່ງ',
        nonadjust: 'ສິນຄ້າທີ່ບໍ່ໄດ້ປັບສະຕັອກ',
        txtnonadjust: 'ລາຍງານສິນຄ້າທີ່ບໍ່ໄດ້ປັບສະຕັອກ',
        stockInReport: 'ລາຍງານນຳສະຕັອກເຂົ້າຕາມສິນຄ້າ',
        stockOutReport: 'ລາຍງານນຳສະຕັອກອອກຕາມສິນຄ້າ',
        stockIn: 'ນຳສະຕັອກເຂົ້າຕາມສິນຄ້າ',
        stockOut: 'ນຳສະຕັອກອອກຕາມສິນຄ້າ',
        exportProduct: 'ສົ່ງອອກສິນຄ້າ',
        txtExportProduct: 'ລາຍງານສົ່ງອອກສິນຄ້າ',
        cashDrawer: 'ລິ້ນຊັກ',
        txtCashDrawerr: 'ລາຍງານຈັດການເງິນສົດ',
        cashRevenue: 'ລາຍຮັບເງິນສົດ',
    },
    drawer: {
        cashDrawer: 'ລິ້ນຊັກ',
        txtCashDrawerr: 'ລາຍງານຈັດການເງິນສົດ',
        cashRevenue: 'ສະຫຼຸບລາຍຮັບ-ລາຍຈ່າຍ',
        txtcashRevenue: 'ລາຍງານສະຫຼຸບລາຍຮັບ-ລາຍຈ່າຍ',
    },
    member: {
        txtmember: 'ສະມາຊິກ',
        register: 'ລົງທະບຽນຮ້ານ (LINE OA)',
        loyaltyPoint: 'ຄະແນນສະສົມ',
        storeCredit: 'ເຄຣດິດຮ້ານ',
        deal: 'ດີລ',
        giftVoucher: 'ບັດຂອງຂວັນ',
        referral: 'ເຊີນ',
        crm: 'Silom CRM',
    },
    unableStockDescription: 'ບໍ່ສາມາດແກ້ໄຂສິນຄ້າໄດ້ ເນື່ອງຈາກມີການອັບເດດສະຕັອກຫຼັງສ້າງເອກະສານ.',
    noItem: 'ບໍ່ມີລາຍການ',
    enterProductName: 'ໃສ່ຊື່ສິນຄ້າ',
    ByCategory: 'ຕາມໝວດໝູ່',
    ByCategoryDetail: 'ລາຍລະອຽດຕາມໝວດໝູ່',
    maximum: 'ສູງສຸດ',
    selectZone: 'ເລືອກໂຊນ',
    minimum: 'ຕ່ຳສຸດ',
    unlimited: 'ບໍ່ຈຳກັດ',
    startTime: 'ເວລາເລີ່ມ',
    endTime: 'ເວລາສິ້ນສຸດ',

    "errorMessages": {
        "qrExpired": "QR Code ໝົດອາຍຸ",
        "qrNotFound": "ບໍ່ພົບ QR Code",
        "paymentSuccess": "ຊຳລະສຳເລັດ",
        "invalidQrType": "ປະເພດ QR Code ບໍ່ຖືກຕ້ອງ",
        "tableMoved": "ຍ້າຍໂຕະແລ້ວ",
        "receiptVoided": "ບິນຖືກຍົກເລີກແລ້ວ"
    },
    "errorDescriptions": {
        "qrExpired": "QR Code ທີ່ທ່ານໃຊ້ໝົດອາຍຸແລ້ວ. <br>ກະລຸນາຕິດຕໍ່ພະນັກງານ.",
        "qrNotFound": "ບໍ່ພົບຂໍ້ມູນ QR Code ສຳລັບສັ່ງອາຫານ. <br>ກະລຸນາຕິດຕໍ່ພະນັກງານ.",
        "paymentSuccess": "ຂອບໃຈທີ່ໃຊ້ບໍລິການ!",
        "invalidQrType": "ກະລຸນາຕິດຕໍ່ພະນັກງານເພື່ອຮັບ QR Code ແບບ dynamic.",
        "tableMoved": "ກະລຸນາຕິດຕໍ່ພະນັກງານເພື່ອຮັບ QR Code ໃໝ່.",
        "receiptVoided": "ຂອບໃຈທີ່ໃຊ້ບໍລິການ.<br>ກະລຸນາຕິດຕໍ່ພະນັກງານຖ້າຕ້ອງການຄວາມຊ່ວຍເຫຼືອ."
    },
    waitForServe: 'ລໍຖ້າເສີບ',
    DineInPaymentDetails: 'ການຊຳລະ',
    silomPayProDesp: 'ການຊຳລະທີ່ປອດໄພໂດຍ Silom Pay Easy',
    billDetail: 'ລາຍລະອຽດບິນ',
    minute: 'ນາທີ',
    paymentTImeExpired: 'ໝົດເວລາ',
    openApp: 'ເປີດແອັບ',
    callPayStaffSuccess: 'ເອີ້ນພະນັກງານແລ້ວ<br>ກະລຸນາລໍຖ້າ ເພື່ອດຳເນີນການຊຳລະ',
    account: 'ບັນຊີ',
    refNumber: 'ເລກອ້າງອິງ',
    QRCodeBBL: 'QR Code ບັດເຄຣດິດ',
    trackOrderStatus: 'ຕິດຕາມສະຖານະຄຳສັ່ງ',
    all: 'ທັງໝົດ',
    noOrderThisStatus: 'ບໍ່ມີຄຳສັ່ງໃນສະຖານະນີ້',
    orderCompleteThanks: 'ຂອບໃຈທີ່ໃຊ້ບໍລິການ!',
    OnPreparingYourOrder: 'ກຳລັງກະກຽມຄຳສັ່ງຂອງທ່ານ...',
    goToTracking: 'ໄປໜ້າຕິດຕາມ',
    "dine-in": 'ທານໃນຮ້ານ',
    typeOfOrder: 'ປະເພດຄຳສັ່ງ',
    queue: 'ຄິວ',
    cooking: 'ກຳລັງປຸງ',
    orderedAt: 'ສັ່ງເມື່ອ',
    orderTimeStatus: 'ເວລາສັ່ງ',
    acceptTimeStatus: 'ເວລາຮັບ',
    estTimeStatus: 'ເວລາປະມານ',
    newOrderDelivery: 'ຄຳສັ່ງໃໝ່',
    acceptOrderDelivery: 'ຮັບຄຳສັ່ງ',
    readyToServeDelivery: 'ພ້ອມເສີບ',
    orderCompleted: 'ຄຳສັ່ງສິ້ນສຸດ',
    orderCanceled: 'ຄຳສັ່ງຖືກຍົກເລີກ',
    readyToShip: 'ພ້ອມຈັດສົ່ງ',
    scanForPayment: 'ສະແກນເພື່ອຊຳລະ',
    orderType: 'ປະເພດຄຳສັ່ງ',
    welcomeBack: "ຍິນດີຕ້ອນຮັບກັບມາ 👋",
    welcomeBackDespt: "ເຂົ້າສູ່ລະບົບເພື່ອສັ່ງອາຫານຕໍ່",
    orLoginWith: "ຫຼື ເຂົ້າສູ່ລະບົບດ້ວຍ",
    dontHaveAccount: 'ຍັງບໍ່ມີບັນຊີ?',
    register: 'ລົງທະບຽນ',
    fullName: "ຊື່-ນາມສະກຸນ",
    fullNameDespt: 'ຊື່-ນາມສະກຸນຂອງທ່ານ',
    emailDespt: 'ອີເມວຂອງທ່ານ',
    createPassword: 'ສ້າງລະຫັດຜ່ານ',
    alreadyHaveAccount: 'ມີບັນຊີແລ້ວ',
    verifyEmail: 'ຢືນຢັນອີເມວ',
    enterOTPSentTo: 'ໃສ່ OTP ທີ່ສົ່ງໄປ ',
    enterSixOTP: 'ໃສ່ OTP 6 ຫຼັກ',
    verifyOTP: 'ຢືນຢັນ OTP',
    weWillSentOTPEmail: 'ພວກເຮົາຈະສົ່ງ OTP ໄປອີເມວຂອງທ່ານ',
    enterYourEmail: 'ໃສ່ອີເມວຂອງທ່ານ',
    confirmNewPassword: 'ຢືນຢັນລະຫັດຜ່ານໃໝ່',
    sendOTP: 'ສົ່ງ OTP',
    addPhoneNumber: 'ເພີ່ມເບີໂທ',
    addPhoneForRegister: 'ເພີ່ມເບີໂທສຳລັບລົງທະບຽນ',
    enterPhone: 'ໃສ່ເບີໂທ',
    phoneUsed: 'ເບີໂທນີ້ຖືກໃຊ້ແລ້ວ',
    emailUsed: 'ອີເມວນີ້ຖືກໃຊ້ແລ້ວ',
    enterPassword: 'ໃສ່ລະຫັດຜ່ານ',
    registerEmail: 'ອີເມວທີ່ລົງທະບຽນ',
    otpInvalid6: "ກະລຸນາໃສ່ OTP 6 ຫຼັກທີ່ຖືກຕ້ອງ.",
    emailVerified: "ຢືນຢັນອີເມວສຳເລັດ!",
    emailOrPasswordInvalid: 'ອີເມວ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ',
    pleaseEnterEmail: 'ກະລຸນາໃສ່ອີເມວ',
    otpSentToEmail: "ສົ່ງ OTP ໄປອີເມວແລ້ວ",
    passwordNotMatch: "ລະຫັດຜ່ານບໍ່ກົງກັນ",
    resetPasswordCompleted: 'ລ້າງລະຫັດຜ່ານສຳເລັດ!',
    failResetPassword: 'ລ້າງລະຫັດຜ່ານບໍ່ສຳເລັດ',
    completePhoneFail: 'ລົງທະບຽນເບີໂທບໍ່ສຳເລັດ',
    plaseEnterValidEmail: 'ກະລຸນາໃສ່ອີເມວທີ່ຖືກຕ້ອງ',
    invalidPhoneNumber: 'ເບີໂທຕ້ອງເລີ່ມດ້ວຍ 06, 08, ຫຼື 09 ແລະ ມີ 10 ຫຼັກ',
    example: 'ຕົວຢ່າງ',
    passwordSet: "ຫຼາຍກວ່າ 6 ຕົວອັກສອນ ແລະ ຕ້ອງມີຕົວເລກ",
    SelectTableToAdd: 'ໂຕະ',
    availableTable: 'ວ່າງ',
    unAvailableTable: 'ບໍ່ວ່າງ',
    SelectTableToAddDesp: 'ເລືອກໂຕະສຳລັບທານໃນຮ້ານ<br>ໝາຍເຫດ: ຖ້າຕ້ອງການປ່ຽນໂຕະ, ກະລຸນາຕິດຕໍ່ພະນັກງານ',
    updatedStaus: 'ສະຖານະຖືກອັບເດດແລ້ວ',
    otpExpired: 'OTP ໝົດອາຍຸ',
    and: "ແລະ",
    emailOTP: "OTP ອີເມວ",
    emailOTPDesp: "ໃສ່ OTP ທີ່ໄດ້ຮັບຜ່ານອີເມວ",
    phoneOTP: "OTP ເບີໂທ",
    phoneOTPDesp: "ໃສ່ OTP ທີ່ໄດ້ຮັບຜ່ານ SMS",
    checkSpamBox: '* ຖ້າທ່ານບໍ່ໄດ້ຮັບອີເມວ, ກະລຸນາກວດ Spam ຫຼື Junk folder. ບາງຄັ້ງອາດໃຊ້ເວລາສອງສາມນາທີ.',
    DineInPaymentPending: 'ລໍຖ້າການຊຳລະ',
    visitProceedPayment: 'ໄປໜ້າຊຳລະ',
    proceedPayment: "ດຳເນີນການຊຳລະ",
    proceedPaymentDesp: "ບິນນີ້ກຳລັງດຳເນີນການຊຳລະ.<br>ຖ້າທ່ານຕ້ອງການສັ່ງເພີ່ມ,<br>ກະລຸນາຍົກເລີກການຊຳລະທີ່ກຳລັງດຳເນີນກ່ອນ",
    queueIndex: 'ຄິວ',
    otpSentToPhone: 'ສົ່ງ OTP ຜ່ານ SMS ແລ້ວ.',
    failToSendOTP: 'ສົ່ງ OTP ບໍ່ສຳເລັດ',
    somethingWentWrong: 'ມີບາງຢ່າງຜິດພາດ',
    tableHasNoOrder: 'ໂຕະບໍ່ມີຄຳສັ່ງ',
    kbankProceedPaymentDesp: 'ບິນນີ້ກຳລັງດຳເນີນການຊຳລະ.<br>ຖ້າທ່ານຕ້ອງການສັ່ງເພີ່ມ ຫຼື ປ່ຽນວິທີການຊຳລະ,<br>ກະລຸນາຍົກເລີກການຊຳລະທີ່ກຳລັງດຳເນີນ'
,
  openHours: 'ເປີດ',
}

export default messages
